// Единая точка событий игры: пробрасывает их в глобальную обёртку аналитики
// (/analytics.js — Метрика и GA4) и в клиент лидерборда.
//
// Раньше в каждой игре лежал свой шим analytics.ts, отличавшийся только id
// игры. Теперь шим игры — одна строка поверх этого модуля, а всё поведение
// живёт здесь: игры при этом не знают ни про лидерборд, ни про сеть.
import { handleGameEvent } from './leaderboard'

type Params = Record<string, unknown>

interface AnalyticsWrapper {
  track(name: string, params?: Params): void
}

export function createTracker(game: string) {
  return function track(name: string, params: Params = {}): void {
    ;(window as unknown as { analytics?: AnalyticsWrapper }).analytics?.track(name, { game, ...params })
    handleGameEvent(game, name, params)
  }
}
